import { Group, Stack, Textarea } from "@assetwatch/ui";
import type { ProcedureCategoryOption } from "../../../queries/procedureAuthoringApi";
import { ProcedureCategoryTagPicker } from "./ProcedureCategoryTagPicker";

export function ProcedureAuthoringHeader({
  categories,
  categoryOptions,
  categoryError,
  description,
  editable,
  errors,
  onCategoriesChange,
  onDescriptionChange,
  onTitleChange,
  title,
}: {
  categories: string[];
  categoryOptions: ProcedureCategoryOption[];
  categoryError?: string;
  description: string;
  editable: boolean;
  errors: { category?: string; title?: string };
  onCategoriesChange: (categories: string[]) => void;
  onDescriptionChange: (description: string) => void;
  onTitleChange: (title: string) => void;
  title: string;
}) {
  return (
    <Stack gap={8}>
      <Group gap={8} wrap="wrap">
        <ProcedureCategoryTagPicker
          categories={categories}
          options={categoryOptions}
          error={errors.category ?? categoryError}
          errorKey="category"
          editable={editable}
          onChange={onCategoriesChange}
        />
      </Group>
      <div className="w-full min-w-0">
        <input
          aria-label="Procedure title"
          aria-invalid={Boolean(errors.title)}
          data-procedure-error="title"
          className={`w-full max-w-full rounded-(--radius-xs) border bg-transparent px-(--spacing-8) py-(--spacing-4) font-(family-name:--font-family-display) text-(length:--font-size-headline-xsmall) font-(number:--font-weight-semibold) text-text-default outline-none placeholder:text-text-subtle focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring lg:max-w-[33%] ${errors.title ? "border-input-error-outline" : "border-transparent"}`}
          onChange={(event) => onTitleChange(event.target.value)}
          placeholder="Add a title"
          value={title}
        />
      </div>
      <Textarea
        aria-label="Procedure description"
        data-procedure-error="description"
        onChange={(event) => onDescriptionChange(event.target.value)}
        placeholder="Add a description…"
        rows={2}
        value={description}
      />
    </Stack>
  );
}
